// OWNED BY THE VISIT AUTHOR. Nothing outside this namespace belongs here, and
// nothing here belongs in another file: this module exists so that the VISIT
// work and the rest of the app can be written at the same time without two
// people editing one map.
export const visit = {
  // ── visits ───────────────────────────────────────────────────────────
  'visit.number': 'ویزیت {{n}}',
  'visit.status.open': 'باز',
  'visit.status.closed': 'بسته',
  'visit.placeholder.title': 'فضای ویزیت در حال ساخت است',
  'visit.placeholder.body': 'یادداشت SOAP، تشخیص‌ها، نسخه و دستورات به‌زودی اینجا قرار می‌گیرند.',
  'visit.placeholder.back': 'بازگشت به پرونده',

  // ── clinical vocabulary — core.md §5.3 ───────────────────────────────
  'clinical.dx.kind.primary': 'اصلی',
  'clinical.dx.kind.secondary': 'ثانویه',
  'clinical.dx.kind.differential': 'افتراقی',
  'clinical.dx.status.active': 'فعال',
  'clinical.dx.status.resolved': 'برطرف‌شده',
  'clinical.dx.status.ruled_out': 'رد شده',
  'clinical.rx.route.oral': 'خوراکی',
  'clinical.rx.route.im': 'عضلانی',
  'clinical.rx.route.iv': 'وریدی',
  'clinical.rx.route.sc': 'زیرجلدی',
  'clinical.rx.route.topical': 'موضعی',
  'clinical.rx.route.inhaled': 'استنشاقی',
  'clinical.rx.route.rectal': 'رکتال',
  'clinical.rx.route.ophthalmic': 'چشمی',
  'clinical.rx.route.otic': 'گوشی',
  'clinical.rx.route.nasal': 'بینی',
  'clinical.rx.route.sublingual': 'زیرزبانی',
  'clinical.rx.route.other': 'سایر',
  'clinical.order.type.lab': 'آزمایش',
  'clinical.order.type.imaging': 'تصویربرداری',
  'clinical.order.type.procedure': 'پروسیجر',
  'clinical.order.type.referral': 'ارجاع',
  'clinical.order.type.other': 'سایر',
  'clinical.order.urgency.routine': 'عادی',
  'clinical.order.urgency.urgent': 'فوری',
  'clinical.order.urgency.stat': 'آنی',
  'clinical.order.status.ordered': 'ثبت‌شده',
  'clinical.order.status.resulted': 'نتیجه ثبت شد',
  'clinical.order.status.cancelled': 'لغو شد',
  'clinical.origin.manual': 'ثبت‌شده توسط شما',
  'clinical.origin.ai': 'از پیشنهاد دستیار',
  'clinical.differential.likelihood.high': 'محتمل',
  'clinical.differential.likelihood.medium': 'ممکن',
  'clinical.differential.likelihood.low': 'کم‌احتمال',
  'clinical.interaction.severity.severe': 'شدید',
  'clinical.interaction.severity.moderate': 'متوسط',
  'clinical.interaction.severity.mild': 'خفیف',
  'clinical.interaction.type.interaction': 'تداخل دارویی',
  'clinical.interaction.type.contraindication': 'منع مصرف',
  'clinical.interaction.type.allergy': 'حساسیت',
  'clinical.interaction.type.black_box': 'هشدار جعبه‌سیاه',
  'clinical.interaction.source.rule_engine_static': 'جدول قواعد',
  'clinical.interaction.source.rule_engine_rxnorm': 'قواعد RxNorm',
  'clinical.interaction.source.rule_engine_contraindication': 'قواعد منع مصرف',
  'clinical.interaction.source.rule_engine_allergy': 'قواعد حساسیت',
  'clinical.interaction.source.rule_engine_openfda': 'openFDA',
  'clinical.interaction.source.llm': 'مدل زبانی',

  // ── the assistant (shared pieces: cost chip, voice) ──────────────────
  'assistant.cost': '{{parseh}} پارسه',
  'assistant.costBefore': 'هزینه: {{parseh}} پارسه',
  'assistant.costFree': 'رایگان',
  'assistant.balance': '{{parseh}} پارسه دارید',
  'assistant.noCredits.title': 'پارسهٔ کافی ندارید',
  'assistant.noCredits.body': 'شارژ کنید یا تا اعتبار رایگان ماه بعد صبر کنید. آنچه نوشته‌اید از بین نرفته است.',
  'assistant.noCredits.action': 'شارژ پارسه',
  'assistant.voice.title': 'شرح حال را دیکته کنید',
  'assistant.voice.body': 'بیمار را شفاهی توضیح دهید، سپس پیش از ذخیره، آنچه را فهمیده بازبینی کنید.',
  'assistant.voice.start': 'شروع دیکته',
  'assistant.voice.stop': 'توقف',
  'assistant.voice.listening': 'در حال شنیدن…',
  'assistant.voice.unsupported': 'این مرورگر تبدیل گفتار به متن ندارد. متن را تایپ یا جای‌گذاری کنید.',
  'assistant.voice.transcript': 'متن شنیده‌شده',
  'assistant.voice.transcriptPlaceholder': 'آقای ۵۴ ساله با درد فشارندهٔ قفسهٔ سینه از صبح امروز، دیابت شناخته‌شده، مصرف متفورمین…',
  'assistant.voice.parse': 'تبدیل به شرح حال',
  'assistant.voice.parsing': 'در حال خواندن…',
  'assistant.voice.needsTranscript': 'هنوز متنی برای خواندن وجود ندارد.',
  'assistant.voice.draft.title': 'پیش‌نویس — هنوز چیزی ذخیره نشده',
  'assistant.voice.draft.body': 'هرچه را نمی‌خواهید بردارید و سپس تأیید کنید.',
  'assistant.voice.draft.none': 'چیزی که بتواند در بخش‌های شرح حال جای بگیرد پیدا نشد.',
  'assistant.voice.draft.confirm': 'افزودن موارد انتخاب‌شده',
  'assistant.voice.draft.confirming': 'در حال افزودن…',
  'assistant.voice.draft.discard': 'دور انداختن پیش‌نویس',
  'assistant.voice.draft.demographics': 'همچنین شنیده شد',
  'assistant.voice.draft.demographicsNote': 'این‌ها اعمال نمی‌شوند؛ اگر می‌خواهید، بیمار را ویرایش کنید.',
  'assistant.voice.applied': '{{count}} بخش به شرح حال افزوده شد.',

  'visit.back': 'بازگشت به پرونده',
  'visit.backToRecord': 'بازگشت به پرونده',
  'visit.notFound': 'این ویزیت پیدا نشد',
  'visit.end': 'پایان ویزیت',
  'visit.reopen': 'بازگشایی',
  'visit.cancel': 'لغو ویزیت',
  'visit.elapsed': '{{h}} ساعت و {{m}} دقیقه از ویزیت',
  'visit.closedAt': 'بسته شده در {{date}}',
  'visit.save.saved': 'ذخیره شد',
  'visit.save.saving': 'در حال ذخیره…',
  'visit.save.failed': 'ذخیره نشد — تلاش دوباره',

  'visit.tabs.aria': 'بخش‌های ویزیت',
  'visit.tabs.note': 'یادداشت',
  'visit.tabs.diagnoses': 'تشخیص',
  'visit.tabs.rx': 'نسخه',
  'visit.tabs.orders': 'دستورات',

  'visit.soap.s': 'S',
  'visit.soap.o': 'O',
  'visit.soap.a': 'A',
  'visit.soap.p': 'P',
  'visit.soap.sCaption': 'شرح حال',
  'visit.soap.oCaption': 'معاینه و یافته‌ها',
  'visit.soap.aCaption': 'ارزیابی',
  'visit.soap.pCaption': 'برنامه',
  'visit.soap.suggest': 'پیشنهاد دستیار',
  'visit.soap.suggesting': 'در حال نوشتن پیش‌نویس…',
  'visit.soap.suggestNote': 'پیش‌نویس است؛ تا خودتان اعمال نکنید چیزی نوشته نمی‌شود.',
  'visit.soap.listening': 'در حال شنیدن…',
  'visit.soap.dictate': 'دیکته در این بخش',
  'visit.soap.dictateStop': 'توقف دیکته',
  'visit.soap.reviewTitle': 'بازبینی یادداشت پیشنهادی',
  'visit.soap.reviewEmpty': 'چیزی که در بخش‌های SOAP جای بگیرد پیشنهاد نشد.',
  'visit.soap.reviewCurrent': 'آنچه خودتان نوشته‌اید',
  'visit.soap.applyReplace': 'جایگزینی',
  'visit.soap.applyAppend': 'افزودن در ادامه',

  'visit.dx.title': 'تشخیص',
  'visit.dx.icd': 'کد ICD',
  'visit.dx.icdHint': 'اختیاری — یک حرف و دو رقم، مثل I21.0',
  'visit.dx.icdInvalid': 'قالب این مقدار شبیه کد ICD نیست',
  'visit.dx.kind': 'نوع',
  'visit.dx.status': 'وضعیت',
  'visit.dx.note': 'یادداشت',
  'visit.dx.add': 'افزودن تشخیص',
  'visit.dx.empty': 'هنوز تشخیصی ثبت نشده',
  'visit.dx.emptyBody': 'آنچه را محتمل می‌دانید بنویسید، یا تشخیص افتراقی بخواهید.',
  'visit.dx.moveUp': 'یک پله بالاتر',
  'visit.dx.moveDown': 'یک پله پایین‌تر',
  'visit.dx.differential': 'تشخیص افتراقی دستیار',
  'visit.dx.differentialBusy': 'در حال فکر کردن…',
  'visit.dx.differentialLast': 'آخرین افتراقی',
  'visit.dx.differentialTitle': 'تشخیص افتراقی',
  'visit.dx.differentialEmpty': 'فهرست جداشدنی برنگشت؛ توضیح بالا را بخوانید.',
  'visit.dx.discriminators': 'وجه افتراق',
  'visit.dx.nextSteps': 'گام بعدی',
  'visit.dx.addToList': 'افزودن به تشخیص‌ها',
  'visit.dx.addedToList': 'افزوده شد',

  'visit.rx.drug': 'دارو',
  'visit.rx.drugHint': 'از فهرست دارویی انتخاب کنید، یا نامی خارج از آن را تایپ کنید',
  'visit.rx.searching': 'در حال جستجو…',
  'visit.rx.freeText': 'خارج از فهرست دارویی',
  'visit.rx.freeTextNote': 'ردیف‌های خارج از فهرست دارویی در بررسی تداخل نادیده گرفته می‌شوند.',
  'visit.rx.dose': 'دوز',
  'visit.rx.route': 'راه مصرف',
  'visit.rx.frequency': 'تناوب',
  'visit.rx.duration': 'مدت',
  'visit.rx.quantity': 'تعداد',
  'visit.rx.instructions': 'دستور مصرف',
  'visit.rx.detail': 'دستور',
  'visit.rx.add': 'افزودن دارو',
  'visit.rx.empty': 'هنوز دارویی تجویز نشده',
  'visit.rx.emptyBody': 'داروهایی را که در این ویزیت تجویز می‌کردید بیفزایید.',
  'visit.rx.check': 'بررسی تداخل',
  'visit.rx.checking': 'در حال بررسی…',
  'visit.rx.lastCheck': 'آخرین بررسی',
  'visit.rx.interactionTitle': 'بررسی تداخل دارویی',
  'visit.rx.interactionNone': 'تداخلی یافت نشد',
  'visit.rx.interactionNoneBody': 'برای ردیف‌هایی که بررسی توانست ببیند. فهرست بررسی‌نشده‌ها را در ادامه بخوانید.',
  'visit.rx.interactionSource': 'منبع',
  'visit.rx.skippedTitle': 'این ردیف‌ها بررسی نشدند',
  'visit.rx.skippedBody': 'دستی تایپ شده‌اند و کد دارویی ندارند، پس بررسی نتوانست آن‌ها را پیدا کند.',
  'visit.rx.print': 'چاپ نسخه',
  'visit.rx.printTitle': 'نسخهٔ تمرینی',
  'visit.rx.printAction': 'چاپ',
  'visit.rx.printFooter': 'سندی تمرینی است؛ اعتبار ندارد و هرگز نباید به داروخانه ارائه شود.',
  'visit.rx.watermark': 'نسخهٔ تمرینی — فاقد اعتبار',
  'visit.rx.studentNumber': 'شمارهٔ دانشجویی',

  'visit.orders.add': 'افزودن دستور',
  'visit.orders.fromCatalog': 'از فهرست خدمات',
  'visit.orders.title': 'دستور',
  'visit.orders.type': 'نوع',
  'visit.orders.urgency': 'فوریت',
  'visit.orders.notes': 'دلیل / توضیح',
  'visit.orders.empty': 'هنوز دستوری ثبت نشده',
  'visit.orders.emptyBody': 'آزمایش‌ها و تصویربرداری‌های لازم این ویزیت را ثبت کنید.',
  'visit.orders.pickTitle': 'انتخاب از فهرست خدمات',
  'visit.orders.pickEmpty': 'موردی مطابق جستجو نیست؛ دستور را تایپ کنید.',
  'visit.orders.search': 'جستجو در فهرست خدمات',
  'visit.orders.recordResult': 'ثبت نتیجه',
  'visit.orders.cancelOrder': 'لغو دستور',
  'visit.orders.resultTitle': 'ثبت نتیجه',
  'visit.orders.resultBody': 'نتیجه',
  'visit.orders.resultRows': 'مقادیر',
  'visit.orders.resultAddRow': 'افزودن ردیف',
  'visit.orders.resultName': 'آزمایش',
  'visit.orders.resultValue': 'مقدار',
  'visit.orders.resultUnit': 'واحد',
  'visit.orders.resultRef': 'محدودهٔ مرجع',
  'visit.orders.resultSave': 'ذخیرهٔ نتیجه',
  'visit.orders.resultFlag': 'وضعیت مقدار',
  'visit.orders.resultFlagNone': '—',
  'visit.orders.resultEmpty': 'نتیجه‌ای بنویسید یا دست‌کم یک ردیف مقدار وارد کنید.',
  'visit.orders.suggest': 'پیشنهاد دستورات',
  'visit.orders.suggestBusy': 'در حال فکر کردن…',
  'visit.orders.suggestLast': 'آخرین پیشنهادها',
  'visit.orders.suggestTitle': 'دستورهای پیشنهادی',
  'visit.orders.suggestEmpty': 'دستور جداشدنی پیشنهاد نشد؛ توضیح بالا را بخوانید.',
  'visit.orders.suggestAdd': 'افزودن موارد انتخاب‌شده ({{count}})',

  'visit.rail.title': 'پرونده',
  'visit.rail.expand': 'باز کردن ستون پرونده',
  'visit.rail.collapse': 'جمع کردن ستون پرونده',
  'visit.rail.allergies': 'هشدار حساسیت',
  'visit.rail.identity': 'مشخصات',
  'visit.rail.vitals': 'علائم حیاتی',
  'visit.rail.vitalsAdd': 'ثبت',
  'visit.rail.vitalsPlaceholder': 'فشار ۱۲۰/۸۰ · نبض ۷۲',
  'visit.rail.medications': 'داروهای فعلی',
  'visit.rail.problems': 'مشکلات فعال',
  'visit.rail.pmh': 'سابقهٔ بیماری',
  'visit.rail.labs': 'آزمایش‌ها',
  'visit.rail.history': 'شرح حال',
  'visit.rail.ageYears': '{{n}} ساله',
  'visit.rail.noVitals': 'علائم حیاتی ثبت نشده است.',
  'visit.rail.noMedications': 'داروی فعالی ثبت نشده است.',
  'visit.rail.noProblems': 'مشکل فعالی ثبت نشده است.',
  'visit.rail.noPmh': 'هنوز چیزی نوشته نشده است.',
  'visit.rail.noLabs': 'هنوز آزمایشی نوشته نشده است.',
  'visit.rail.noHistory': 'شرح حال خالی است.',
  'visit.rail.emptyList': 'هنوز چیزی اینجا نیست.',

  'visit.copilot.title': 'دستیار',
  'visit.copilot.aria': 'بخش‌های دستیار',
  'visit.copilot.ask': 'پرسش',
  'visit.copilot.differential': 'افتراقی',
  'visit.copilot.suggestions': 'پیشنهادها',
  'visit.copilot.askEmpty': 'دربارهٔ همین ویزیت بپرسید؛ پرونده و یادداشتی که می‌نویسید را می‌خواند.',
  'visit.copilot.thinking': 'در حال فکر کردن…',
  'visit.copilot.placeholder': 'دربارهٔ این ویزیت بپرسید',
  'visit.copilot.send': 'بپرس',
  'visit.copilot.offline': 'آفلاین — دستیار در دسترس نیست.',
  'visit.copilot.open': 'باز کردن دستیار',
  'visit.copilot.collapse': 'جمع کردن دستیار',
  'visit.copilot.refresh': 'به‌روزرسانی',
  'visit.copilot.openCards': 'دیدن کارت‌ها',
  'visit.copilot.differentialEmpty': 'در این ویزیت هنوز افتراقی خواسته نشده است.',
  'visit.copilot.soapSuggestion': 'پیشنهاد یادداشت',
  'visit.copilot.orderSuggestion': 'پیشنهاد دستورات',
  'visit.copilot.suggestionsEmpty': 'هنوز پیشنهادی در این ویزیت وجود ندارد.',
  'visit.copilot.reopen': 'باز کردن دوباره',

  'visit.close.title': 'پایان ویزیت',
  'visit.close.summary': 'خلاصهٔ ویزیت',
  'visit.close.summaryHint': 'اختیاری. از سطر اول ارزیابی و برنامه پیش‌نویس شده است.',
  'visit.close.warningsTitle': 'پیش از بستن',
  'visit.close.warningsNote': 'هیچ‌کدام از این‌ها مانع بستن ویزیت نیست.',
  'visit.close.warning.emptyNote': 'یادداشت ویزیت خالی است.',
  'visit.close.warning.noDiagnoses': 'هیچ تشخیصی ثبت نشده است.',
  'visit.close.warning.openSuggestions': 'یک پیشنهاد دستیار هنوز باز و بازبینی‌نشده است.',
  'visit.close.ending': 'در حال بستن…',
  'visit.close.saveFailed': 'یادداشت ذخیره نشد، بنابراین ویزیت بسته نشد',

  'visit.cancelConfirm.title': 'این ویزیت لغو شود؟',
  'visit.cancelConfirm.body': '{{dx}} تشخیص، {{rx}} دارو و {{orders}} دستور حذف می‌شود. علائم حیاتی و شرح حال در پرونده می‌مانند.',
  'visit.cancelConfirm.confirm': 'حذف ویزیت',

  'visit.offline.title': 'اتصال به سرویس قطع است',
  'visit.offline.body': 'آنچه می‌نویسید روی همین دستگاه نگه داشته می‌شود و با بازگشت اتصال ارسال می‌گردد.',

  'visit.toast.ended': 'ویزیت بسته شد.',
  'visit.toast.cancelled': 'ویزیت حذف شد.',
  'visit.toast.discardedDraft': 'پیش‌نویس محلی یادداشت قدیمی‌تر از نسخهٔ ذخیره‌شده بود و کنار گذاشته شد.',

  'visit.shortcuts.group': 'ویزیت',
  'visit.shortcuts.save': 'ذخیرهٔ فوری یادداشت',
  'visit.shortcuts.tab1': 'یادداشت',
  'visit.shortcuts.tab2': 'تشخیص',
  'visit.shortcuts.tab3': 'نسخه',
  'visit.shortcuts.tab4': 'دستورات',
  'visit.shortcuts.send': 'ارسال پرسش',
  'visit.shortcuts.end': 'پایان ویزیت',
};

export default visit;
